export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge":604800,"secure":true},
 clients: {"default":{"httpEndpoint":"","authType":"Bearer","authHeader":"Authorization","tokenName":"apollo:default.token","tokenStorage":"cookie"}}
}